import Vue from "vue";
import Router from "vue-router";
import index from "@/components/layouts/index";
import home from "@/views/home/home";
import community from "@/views/home/community";
import match from "@/views/home/match";
import camp from "@/views/home/camp";
import insideCamp from "@/views/home/insideCamp";
import outsideCamp from "@/views/home/outsideCamp";
import campDetail from "@/views/home/campDetail"
import matchDetail from "@/views/home/matchDetail";
import taskDetail from "@/views/home/taskDetail";
import courseDetail from "@/views/home/courseDetail"
import parents from "@/views/home/parents";

import friends from "@/views/home/friends";

import mymenu from "@/views/my/mymenu";
import myIndex from "@/components/layouts/myIndex";
import mycenter from "@/views/my/mycenter";
import shopping from "@/views/my/shopping";
import goodsDetail from "@/views/my/goodsDetail";
import mycourse from "@/views/my/mycourse";
import myunit from "@/views/my/myunit";
import attendclass from "@/views/my/attendclass";

import register from "@/views/home/register";
import login from "@/views/home/login"


import onlyHeader from "@/components/layouts/onlyHeader";
import frame from "@/views/frame";
import onehour from "@/views/home/onehour";
import gamecourse from "@/views/home/gamecourse";

import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";

Vue.use(Router);
Vue.use(ViewUI);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      redirect: "/home",
      children: [
        {
          path: "/home", // 首页
          name: "home",
          component: home
        },
        {
          path: "/community", // 社区
          name: "community",
          component: community
        },
        {
          path: "/match", // 赛事
          name: "match",
          component: match
        },
        {
          path: "/camp", // 营地
          name: "camp",
          component: camp
        },
        {
          path: "/inside-camp", // 国内营地
          name: "insideCamp",
          component: insideCamp
        },
        {
          path: "/outside-camp", // 国外营地
          name: "outsideCamp",
          component: outsideCamp
        },
        {
          path: "/camp-detail", // 赛事详情
          component: campDetail
        },
        {
          path: "/match-detail", // 赛事详情
          component: matchDetail
        },
        {
          path: "/task-detail", // 作业详情
          component: taskDetail
        },
        {
          path: "/course-detail", // 课程详情
          component: courseDetail
        },
        {
          path: "/login", // 登录
          component: login
        },
        {
          path: "/register", // 注册
          component: register
        },
        {
          path: "/friends", // 好友
          component: friends
        },
        {
          path: "/parents", // 家长
          component: parents
        },
      ]
    },
    {
      path: "/onlyHeader",
      name: "onlyHeader",
      component: onlyHeader,
      children:[
        {
          path: "/frame", //页面框架
          name: "frame",
          component: frame
        },
        {
          path: "/onehour", //编程一小时
          name: "onehour",
          component: onehour
        },
        {
          path: "/gamecourse", //游戏课程
          name: "gamecourse",
          component: gamecourse
        }
      ]
    },
    {
      path: "/myIndex",
      name: "myIndex",
      component: myIndex,
      children: [
        {
          path: "/mymenu", // 我的课堂
          name: "mymenu",
          component: mymenu
        },
        {
          path: "/attendclass", // 上课页面
          name: "attendclass",
          component: attendclass
        },
        {
          path: "/mycourse", // 我的课程
          name: "mycourse",
          component: mycourse
        },
        {
          path: "/myunit", // 我的课程单元
          name: "myunit",
          component: myunit
        },
        {
          path: "/mycenter", // 个人中心
          name: "mycenter",
          component: mycenter
        },
        {
          path: "/shopping", // 课程商城
          name: "shopping",
          component: shopping
        },
        {
          path: "/goodsDetail", // 课程商城
          name: "goodsDetail",
          component: goodsDetail
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js